"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDCS3Provider = void 0;
var _queryClient = require("../queryClient");
var _jsxRuntime = require("react/jsx-runtime");
const DCS3Provider = _queryClient.QueryProvider;
const withDCS3Provider = function (Component) {
  return function (props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(DCS3Provider, {
      "data-testid": "withDCS3Provider",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        ...props
      })
    });
  };
};
exports.withDCS3Provider = withDCS3Provider;